// ============================================================================
// view.production — scoped permanent ownership declaration
// ============================================================================
// The Production page's model consumes the app_store planner inputs, legacy
// event RPC, cattle/sheep processing batches, and egg dailys through one
// source-preserving resource. This replaces legacy.all only for the rendered
// Production surface; it makes no claim about the global boot boundary.

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.production',
  obligations: Object.freeze([Object.freeze({id: 'production.sources.core', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
